export const toSnoozeAlertPayload = (alertId: number, snoozeOptionId: number) => ({
  alertId,
  snoozeOptionId
})
